import { DateRange } from 'react-day-picker';
import { sub } from 'date-fns';
import { formatQueryDate } from 'utils';

export const getDefaultRange = (): DateRange => {
  const currentDate = new Date();
  return {
    from: sub(currentDate, { months: 1 }),
    to: currentDate,
  };
};

export const compareDates = (date1: Date, date2: Date) =>
  formatQueryDate(date1) === formatQueryDate(date2);
